// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1nvlU","legacyBtn":"MutateMid_legacyBtn__2zfut"};